<ng-container [ngSwitch]="this.ENTRANCETICKETDESIGN">
  <ng-container *ngSwitchCase="'biletantalya'">
    <div class="biletantalya-container">
      <div class="biletantalya-img">
        <img
          src="{{
            ticket.TICKETURL == null
              ? '../../../../assets/placeholder-image.jpeg'
              : ticket.TICKETURL
          }}"
          alt=""
        />
      </div>
      <div class="biletantalya-bottom">
        <div class="biletantalya-title">
          {{ ticket.TICKETNAME_I18N || ticket.TICKETNAME }}
        </div>
        <div class="biletantalya-description">
          {{ ticket.TICKETDETAIL_I18N || ticket.TICKETDETAIL }}
        </div>
        <div class="biletantalya-button-wrapper">
          <div class="user-main" *ngIf="isShowUserPanel || false">
            <form [formGroup]="ticketForm">
              <div class="row">
                <div class="col-md-12" *ngIf="isShowSelectTicketDate">
                  <div
                    style="
                      color: red;
                      font-size: 13px;
                      padding-top: 5px;
                      padding-bottom: 10px;
                    "
                  >
                    * {{ "Select Date" | translate | async }}
                  </div>
                </div>
                <div class="date col-md-12" *ngIf="isShowSelectTicketDate">
                  <div class="row" style="align-items: center">
                    <div class="col-7">
                      <label for="checkDate">
                        {{ "Date" | translate | async }}
                      </label>
                    </div>
                    <div class="col-5 date-div">
                      <input
                        (change)="changeDate()"
                        id="checkDate"
                        type="date"
                        formControlName="checkDate"
                      />
                    </div>
                  </div>
                </div>
                <span class="user-body" *ngIf="!isLoadNewTicket">
                  <div
                    class="adult-main col-md-12"
                    *ngIf="ticket.SUBTICKETS.ADULT"
                  >
                    <div class="row">
                      <div class="adult-title col-3">
                        {{ "Adult" | translate | async }}
                      </div>
                      <div class="adult-price col-4">
                        <span style="width: 50%">{{
                          ticket.SUBTICKETS.ADULT.PRICE
                        }}</span
                        >{{ ticket.SUBTICKETS.ADULT.CURRENCY }}
                      </div>
                      <div class="adult-count col-5">
                        <div class="count-panel row">
                          <div
                            class="count-decrement col-4"
                            (click)="decrementCount('adultCount')"
                          >
                            -
                          </div>
                          <div class="count col-4">
                            <input type="text" formControlName="adultCount" />
                          </div>
                          <div
                            class="count-increment col-4"
                            (click)="incrementCount('adultCount')"
                          >
                            +
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="children-main col-md-12"
                    *ngIf="ticket.SUBTICKETS.CHILDREN"
                  >
                    <div class="row">
                      <div class="children-title col-3">
                        {{ "Children" | translate | async }}
                      </div>
                      <div class="children-price col-4">
                        <span style="width: 50%">{{
                          ticket.SUBTICKETS.CHILDREN.PRICE
                        }}</span
                        >{{ ticket.SUBTICKETS.CHILDREN.CURRENCY }}
                      </div>
                      <div class="children-count col-5">
                        <div class="count-panel row">
                          <div
                            class="count-decrement col-4"
                            (click)="decrementCount('childrenCount')"
                          >
                            -
                          </div>
                          <div class="count col-4">
                            <input
                              type="text"
                              formControlName="childrenCount"
                            />
                          </div>
                          <div
                            class="count-increment col-4"
                            (click)="incrementCount('childrenCount')"
                          >
                            +
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="button-footer col-md-12">
                    <div class="button-div">
                      <button
                        class="button-close"
                        role="button"
                        (click)="isShowUserPanelFunc()"
                      >
                        {{ "Close" | translate | async }}
                      </button>
                      <button
                        class="button-user"
                        role="button"
                        (click)="addTicket()"
                      >
                        {{ "Add to Cart" | translate | async }}
                      </button>
                    </div>
                  </div>
                </span>
                <span
                  *ngIf="isLoadNewTicket"
                  class="user-body"
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                  "
                >
                  <div
                    *ngIf="isShowNewTicketError"
                    style="color: red; font-size: 10px"
                  >
                    {{ "Not Found Ticket Date" | translate | async }}.
                  </div>

                  <img
                    src="../../../../assets/tail-spin.svg"
                    style="height: 100%"
                    alt=""
                  />
                </span>
              </div>
            </form>
          </div>
          <div class="biletantalya-button" (click)="isShowUserPanelFunc()">
            {{ !isShowUserPanel ? "Bilet Al" : "Paneli Kapat" }}
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <figure class="image-block">
      <!-- (mouseleave)="isShowUserPanelFunc('leave')" -->
      <img
        src="{{
          ticket.TICKETURL == null
            ? '../../../../assets/placeholder-image.jpeg'
            : ticket.TICKETURL
        }}"
        alt=""
      />
      <figcaption>
        <h3 (click)="goster()">
          {{ ticket.TICKETNAME_I18N || ticket.TICKETNAME }}
        </h3>
        <p>
          {{ ticket.TICKETDETAIL_I18N || ticket.TICKETDETAIL }}
        </p>
        <div class="user-main" *ngIf="isShowUserPanel || false">
          <form [formGroup]="ticketForm">
            <div class="row">
              <div class="col-md-12" *ngIf="isShowSelectTicketDate">
                <div
                  style="
                    color: red;
                    font-size: 13px;
                    padding-top: 5px;
                    padding-bottom: 10px;
                  "
                >
                  * {{ "Select Date" | translate | async }}
                </div>
              </div>
              <div class="date col-md-12" *ngIf="isShowSelectTicketDate">
                <div class="row" style="align-items: center">
                  <div class="col-7">
                    <label for="checkDate">
                      {{ "Date" | translate | async }}
                    </label>
                  </div>
                  <div class="col-5 date-div">
                    <input
                      (change)="changeDate()"
                      id="checkDate"
                      type="date"
                      formControlName="checkDate"
                    />
                  </div>
                </div>
              </div>
              <span class="user-body" *ngIf="!isLoadNewTicket">
                <div
                  class="adult-main col-md-12"
                  *ngIf="ticket.SUBTICKETS.ADULT"
                >
                  <div class="row">
                    <div class="adult-title col-3">
                      {{ "Adult" | translate | async }}
                    </div>
                    <div class="adult-price col-4">
                      <span style="width: 50%">{{
                        ticket.SUBTICKETS.ADULT.PRICE
                      }}</span
                      >{{ ticket.SUBTICKETS.ADULT.CURRENCY }}
                    </div>
                    <div class="adult-count col-5">
                      <div class="count-panel row">
                        <div
                          class="count-decrement col-4"
                          (click)="decrementCount('adultCount')"
                        >
                          -
                        </div>
                        <div class="count col-4">
                          <input type="text" formControlName="adultCount" />
                        </div>
                        <div
                          class="count-increment col-4"
                          (click)="incrementCount('adultCount')"
                        >
                          +
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="children-main col-md-12"
                  *ngIf="ticket.SUBTICKETS.CHILDREN"
                >
                  <div class="row">
                    <div class="children-title col-3">
                      {{ "Children" | translate | async }}
                    </div>
                    <div class="children-price col-4">
                      <span style="width: 50%">{{
                        ticket.SUBTICKETS.CHILDREN.PRICE
                      }}</span
                      >{{ ticket.SUBTICKETS.CHILDREN.CURRENCY }}
                    </div>
                    <div class="children-count col-5">
                      <div class="count-panel row">
                        <div
                          class="count-decrement col-4"
                          (click)="decrementCount('childrenCount')"
                        >
                          -
                        </div>
                        <div class="count col-4">
                          <input type="text" formControlName="childrenCount" />
                        </div>
                        <div
                          class="count-increment col-4"
                          (click)="incrementCount('childrenCount')"
                        >
                          +
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="button-footer col-md-12">
                  <div class="button-div">
                    <button
                      class="button-close"
                      role="button"
                      (click)="isShowUserPanelFunc()"
                    >
                      {{ "Close" | translate | async }}
                    </button>
                    <button
                      class="button-user"
                      role="button"
                      (click)="addTicket()"
                    >
                      {{ "Add to Cart" | translate | async }}
                    </button>
                  </div>
                </div>
              </span>
              <span
                *ngIf="isLoadNewTicket"
                class="user-body"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  flex-direction: column;
                "
              >
                <div
                  *ngIf="isShowNewTicketError"
                  style="color: red; font-size: 10px"
                >
                  {{ "Not Found Ticket Date" | translate | async }}.
                </div>

                <img
                  src="../../../../assets/tail-spin.svg"
                  style="height: 100%"
                  alt=""
                />
              </span>
            </div>
          </form>
        </div>
        <div class="button-div-footer">
          <button (click)="isShowUserPanelFunc()">
            {{ !isShowUserPanel ? "Bilet Al" : "Paneli Kapat" }}
          </button>
        </div>
      </figcaption>
    </figure>
  </ng-container>
</ng-container>
